import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {deleteOneUser, loadUser, loadUsers} from "./usersAction";
import {
    ROLE_ADMIN,
    ROLE_AMBASSADOR,
    ROLE_CODIR,
    ROLE_ENJOY,
    ROLE_SPONSOR,
    ROLE_USER
} from "../../permissions/roleTypes";
import styled from "styled-components";
import EditButton from "../buttons/EditButton";
import DeleteButton from "../buttons/DeleteButton";
import AddButtonFullText from "../buttons/AddButtonFullText";
import UserModal from "../modal/UserModal";
import {DisplayForAmbassador} from "../../permissions/DisplayAccordingToRole";
import YesNoModal from "../modal/YesNoModal";
import useFilterUser from "../../custom-hooks/useFilterUser";
import SearchBarUserName from "../search-bar/SearchBarUserName";
import {displayAlert, getImage} from "../../utils/utils";
import accountSVG from "../../images/account.svg";
import TabContainer from "../tab/TabContainer";
import {ALL_FILTER, TAGS_FILTER} from "../tab/filterTypes";
import SearchBarByTag from "../search-bar/SearchBarByTag";
import useTab from "../../custom-hooks/useTab";
import useSearchBar from "../../custom-hooks/useSearchBar";


const UsersSection = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(loadUsers())
    }, [dispatch])

    const {users} = useSelector(state => state.users)

    const [selectedUserId, setSelectedUserId] = useState(0)
    const [addModalIsOpen, setAddModalIsOpen] = useState(false)
    const [editModalIsOpen, setEditModalIsOpen] = useState(false)
    const [deleteModalIsOpen, setOpenDeleteModalIsOpen] = useState(false)
    const [isSent, setIsSent] = useState(false)
    const [isErrors, setIsErrors] = useState(false)
    const [numberOfUser, setNumbersOfUser] = useState(0)
    const [sectionsMenu, setSectionMenu] = useState([])
    const [usersDisplayed, setUsersDisplayed] = useState(users)
    const {sections, toggleSection, activeTab} = useTab(sectionsMenu)
    const {filter, setFilter} = useSearchBar()


    useEffect(() => {
        setSectionMenu([
            {key: ALL_FILTER, label: "Tous", state: true,},
            {key: TAGS_FILTER, label: "Par tag", state: false,},
        ])
    }, [])

    useEffect(() => {
        let selectedSection = sections.filter(s => s.state === true)[0] || {}
        if (Object.keys(selectedSection).length > 0) {
            setFilter(selectedSection.key)
            if (selectedSection.key === ALL_FILTER){
                setUsersDisplayed(users)
            }
        }
    }, [sections, setFilter, users])

    const displayUserRole = (user) => {
        if (user.roles.includes(ROLE_ENJOY)) {
            return "Enjoy"
        }
        if (user.roles.includes(ROLE_CODIR)) {
            return "Codir"
        }
        if (user.roles.includes(ROLE_AMBASSADOR)) {
            return "Ambassadeur"
        }
        if (user.roles.includes(ROLE_USER)) {
            return "Collaborateur"
        }
    }

    const deleteRequest = async (user_id) => {
        try {
            await dispatch(deleteOneUser(user_id))
            setIsSent(true)
            await dispatch(loadUsers())
            setTimeout(() => setOpenDeleteModalIsOpen(false), 500)
        } catch {
            setIsErrors(false)
        }
    }

    const displayModal = () => {
        if (addModalIsOpen) {
            return <UserModal
                setModalIsOpen={setAddModalIsOpen}
            />
        }
        if (editModalIsOpen) {
            return <UserModal
                setModalIsOpen={setEditModalIsOpen}
                isEditAction={true}
            />
        }
        if (deleteModalIsOpen) {
            return <YesNoModal
                name={"cet utilisateur ?"}
                setOpenModal={setOpenDeleteModalIsOpen}
                id={selectedUserId}
                handleClickYesAction={deleteRequest}

            />
        }
    }

    const updateUser = async (user_id) => {
        if (user_id !== 0) {
            await dispatch(loadUser(user_id))
            setEditModalIsOpen(true)
            setSelectedUserId(user_id)
        }
    }


    const {
        getFullNameNoWhiteSpace,
        getFullNameInverseNoWhiteSpace,
        getQueryNoWhiteSpace,
        query,
        setQuery
    } = useFilterUser(users)


    const returnRoles = (role) => {
        if (role === ROLE_AMBASSADOR) {
            return "ambassadeur"
        } else if (role === ROLE_SPONSOR || role === ROLE_USER) {
            return "collaborateur"
        } else if (role === ROLE_CODIR) {
            return "codir"
        } else if (role === ROLE_ADMIN) {
            return "administrateur"
        } else {
            return 'enjoy'
        }
    }


    useEffect(() => {
        setNumbersOfUser(usersDisplayed
            .filter(u =>
                returnRoles(u.roles[0]).includes(query.toLowerCase()) ||
                u.firstName.toLowerCase().includes(query.toLowerCase()) ||
                u.lastName.toLowerCase().includes(query.toLowerCase()) ||
                getFullNameNoWhiteSpace(u).includes(getQueryNoWhiteSpace(query)) ||
                getFullNameInverseNoWhiteSpace(u).includes(getQueryNoWhiteSpace(query)
                )
            ).length)
    }, [getFullNameInverseNoWhiteSpace, getFullNameNoWhiteSpace, getQueryNoWhiteSpace, query, usersDisplayed])


    const displayFilter = (filter) => {
        if (filter === TAGS_FILTER) {
            return (
                <SearchBarByTag
                    data={users}
                    setData={setUsersDisplayed}
                />
            )
        }
    }

    return (
        <Section>
            {displayAlert(isErrors, isSent)}
            <h1> Annuaire</h1>
            <DisplayForAmbassador
                component={
                    <AddButtonFullText
                        id={selectedUserId}
                        setId={setSelectedUserId}
                        setUpdate={setAddModalIsOpen}
                        title={"Ajouter un membre"}
                    />
                }
            />
            <SearchBarUserName
                setQuery={setQuery}
                name={"utilisateur"}
            />
            <TabContainer
                selectedTab={activeTab}
                children={sections}
                toggleSection={toggleSection}
            />
            {displayFilter(filter)}
            <p><Span>{numberOfUser} </Span> utilisateur{numberOfUser > 1 ? "s" : ""}</p>
            <UsersContainer>
                {usersDisplayed.filter(u =>
                    returnRoles(u.roles[0]).includes(query.toLowerCase()) ||
                    u.firstName.toLowerCase().includes(query.toLowerCase()) ||
                    u.lastName.toLowerCase().includes(query.toLowerCase()) ||
                    getFullNameNoWhiteSpace(u).includes(getQueryNoWhiteSpace(query)) ||
                    getFullNameInverseNoWhiteSpace(u).includes(getQueryNoWhiteSpace(query)))
                    .map(u => (
                        <Card key={u.id + "/" + u.lastName + u.firstName}>
                            <div className={'flex-row ai-center'}>
                                <div className={"flex-row ai-center"}>
                                    <img src={getImage(u.photo, accountSVG)} alt={`${u.firstName} ${u.lastName}`}/>
                                    <h2> {u.firstName} {u.lastName} </h2>
                                </div>
                                <div className={'flex-row'} onClick={() => setSelectedUserId(u.id)}>
                                    <DisplayForAmbassador
                                        component={<EditButton
                                            setUpdate={updateUser}
                                            data={u.id}
                                        />}
                                    />
                                    <DisplayForAmbassador
                                        component={<DeleteButton
                                            setOpenDeleteModal={setOpenDeleteModalIsOpen}
                                        />}
                                    />
                                </div>
                            </div>
                            <p><span className={"fw-700"}> email </span> : {u.email} </p>
                            <p><span className={"fw-700"}> téléphone </span> : {u.phone} </p>
                            <p><span className={"fw-700"}> rôle </span> : {displayUserRole(u)} </p>
                        </Card>
                    ))}
            </UsersContainer>
            {displayModal()}
        </Section>
    )
}

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  justify-content: flex-start;
  align-items: center;

  .add-btn {
    align-self: center;
  }

  .search-bar-name {
    align-self: center;
    width: 50%;
  }

  @media (min-width: 900px) {
    padding-left: 1em;
  }

`
const UsersContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 1em 0;
  justify-content: center;
  @media (min-width: 900px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
`
const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--color-white);
  box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
  border-radius: 10px;
  padding: 1em;
  gap: 0.5em;
  width: 20rem;

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }

  div:first-child {
    gap: 0.5em;

    div:first-child {
      flex-grow: 1;

      h2 {
        font-size: 0.90rem;
      }
    }
  }

  @media (min-width: 900px) {
    width: unset;
  }
`

const Span = styled.span`
  font-weight: 800;
  color: var(--color-purple);
  font-size: 150%;
`

export default UsersSection